import type { RouteObject } from "react-router-dom";

export const customReportsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Custom Reports" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { CustomReportsPage } = await import("./custom-reports-page");
          return { Component: CustomReportsPage };
        },
      },
    ],
  },
];
